import { useForm } from 'react-hook-form';
import { Checkbox, FormProvider, SelectTag, Table, TextField, } from '../../../../../components';
import { Button, Container, Dialog, Grid, Paper, Stack, Typography, TextField as MuiTextField, Box, Radio, IconButton } from '@mui/material';
import { useCallback, useEffect, useRef, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { dropdownFetch, getKeyPathValue, request, toast } from '../../../../../utils';
import { useLocation } from 'react-router-dom';
import { CustomButtonn } from '../../../../../components';
import { GENDER_DROPDOWN } from '../../../../../constants/dropdown';
import { AddTrayDetailsForm } from './AddTrayDetailsForm';
import CloseIcon from '@mui/icons-material/Close';


const initialPatientDataObj = {
    data: [],
    loading: false
};
const initialPosDataObj = {
    data: [],
    loading: false
};

const initialTrayRequestDataObj = {
    data: [],
    loading: false
};


export const TrayRequest = () => {
    const doctorIDRef = useRef();
    const { pathname } = useLocation();
    const lastPathSegment = pathname.split('/').pop();
    const [detailList, setDetailList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [currentAction, setCurrentAction] = useState();
    const [selectedRecord, setSelectedRecord] = useState();
    const [patientDataObj, setPatientDataObj] = useState(initialPatientDataObj);
    const [retailSalePosObj, setRetailSalePosObj] = useState(initialPosDataObj);
    const [indoorRegisterationDataObj, setIndoorRegisterationDataObj] = useState(initialPatientDataObj);
    const [trayRequestDataObj, setTrayRequestDataObj] = useState(initialTrayRequestDataObj);
    const [openQueryDialog, setOpenQueryDialog] = useState(false);
    const [originalData, setOriginalData] = useState([]);
    const [input, setInput] = useState('');
    const [isFiltered, setIsFiltered] = useState(false);
    const [opdDialogueOpen, setOpdDialogueOpen] = useState(false)
    const [ipdDialogueOpen, setIpdDialogueOpen] = useState(false)
    const [opdPatientDetail, setOpdPatientDetail] = useState([])
    const [ipdPatientDetail, setIpdPatientDetail] = useState([])
    const [tableData, setTableData] = useState([]);
    const [selectedRow, setSelectedRow] = useState(null);
    const [qty, setQty] = useState('');
    const [opdData, setOpdData] = useState([])
    const [ipdData, setIpdData] = useState([])
    const [posInput, setPosInput] = useState('')
    const [opdInput, setOpdInput] = useState('')
    const [ipdInput, setIpdInput] = useState('')
    const [selectedRadio, setSelectedRadio] = useState('');
    const [posData, setPosData] = useState([])
    const [opdFilterData, setOpdFilterData] = useState({ data: [] });
    const [ipdFilterData, setIpdFilterData] = useState({ data: [] });
    const productRef = useRef()
    const [productStock, setProductStock] = useState([])
    const [doctorDropdown, setDoctorDropdown] = useState([])
    const [sponsorDropdown, setSponsorDropdown] = useState([]);
    const [wardDropdown, setWardDropdown] = useState([])
    const [roomMasterDropdown, setRoomMasterDropdown] = useState([]);
    const [warehouse, setWareHouse] = useState([])
    const [medicineDetailDialogue, setMedicineDetailDialogue] = useState(false)
    const [medicinesDetails, setMedicineDetails] = useState([])
    const [medicineReturnDetails, setMedicineReturnDetails] = useState([])
    const [labDetailDialogue, setLabDetailDialogue] = useState(false)
    const [labDetails, setLabDetails] = useState([])
    const [serviceDialogue, setServiceDialogue] = useState(false)
    const [serviceDetails, setServiceDetails] = useState([])
    const [indentData, setIndentData] = useState([])
    const [selectedIndentRadio, setSelectedIndentRadio] = useState('ipd_indent')
    const [originalOpdData, setOriginalOpdData] = useState([])
    const [cssdDialogueOpen, setCssdDialogeOpen] = useState(false)

    const { getValues } = useForm()
    const methods = useForm({
        resolver: yupResolver(
            Yup.object().shape({
                // location_to: Yup.string().required(' '),
            })
        ),
        defaultValues: {
            date: new Date().toISOString().split('T')[0],
            time: new Date().toLocaleTimeString('en-US', { hour12: false }).slice(0, 5),
        },
        mode: 'all'
    });
    const { handleSubmit, watch, reset, setValue } = methods;

    const IPD_TABLE_HEADER = [
        { header: 'Patient Name', accessor: (row) => row?.patient?.name },
        { header: 'Ipd No.', accessor: 'ipd_no' },
        { header: 'Uhid', accessor: 'uhid' },
        {
            header: 'Ward Name', accessor: (row) => row?.consultant_detail?.room?.ward?.name
        },
    ];

    const OPD_TABLE_HEADER = [
        { header: 'Patient Name', accessor: (row) => `${row?.name_suffix}${row?.first_name}${row?.last_name}` },
        { header: 'Uhid', accessor: 'uhid' },
        {
            header: 'Ward Name', accessor: (row) => row?.consultant_detail?.room?.ward?.name
        },
    ];


    const TABLE_HEADER = [
        { header: 'Req No.', accessor: 'req_no' },
        { header: 'Uhid', accessor: 'uhid' },
        { header: 'Ipd No', accessor: 'ipd_no' },
        { header: 'Patient Name', accessor: (row) => `${row?.patientInfo?.name_suffix}${row?.patientInfo?.first_name}${row?.patientInfo?.last_name}` },

    ];

    const getDoctorDropdown = useCallback(async () => {
        const data = await dropdownFetch('doctor');
        if (!selectedRecord && !getValues('consultant')) {
            const [defaultState] = data.filter(({ status }) => status === 'default');
            setValue('consultant', defaultState?._id);
            if (defaultState) {
                setValue('department', defaultState.qualification_details.department);
            }
        }

        setDoctorDropdown(data);
    }, [selectedRecord, getValues, setValue]);

    const getWardDropdown = useCallback(async () => {
        const data = await dropdownFetch('ward');
        setWardDropdown(data);
    }, []);

    const getRoomMasterDropdown = useCallback(async () => {
        const data = await dropdownFetch('room-master');
        setRoomMasterDropdown(data);
    }, []);


    const getWareHouseDropdown = useCallback(async () => {
        const data = await dropdownFetch('warehouse');
        setWareHouse(data);
    }, []);

    const getSponsorDropdown = useCallback(async () => {
        const data = await dropdownFetch('sponsor');
        if (!selectedRecord) {
            const [defaultSponsor] = data.filter(({ status }) => status === 'default');
            setValue('sponsor', defaultSponsor?._id);
        }
        setSponsorDropdown(data);
    }, []);

    useEffect(() => {
        getDoctorDropdown()
        getSponsorDropdown()
        getWardDropdown()
        getRoomMasterDropdown()
        getWareHouseDropdown()
    }, [getDoctorDropdown, getSponsorDropdown, getWardDropdown, getRoomMasterDropdown, getWareHouseDropdown])


    const formSubmit = async (formValues) => {

        setLoading(true);
        const items = medicinesDetails
        console.log("HELLLLO DETAILSSS", medicinesDetails)
        const payload = {
            ...formValues,
            items,
        };
        const editFlag = selectedRecord && currentAction === 'edit';
        try {
            const response = await request(editFlag ? `/indent-update/${selectedRecord._id}` : '/tray-request-create', {
                method: editFlag ? 'PUT' : 'POST',
                body: payload,
            });

            if (response?.success && response.data) {
                toast(`Successfully ${editFlag ? 'edited' : 'created'} Tray Request`, { variant: 'success' });
                setSelectedRecord(response.data);
                setCurrentAction();
                setLabDetails([])
                setServiceDetails([])
                setMedicineDetails([])
                reset()
            } else {
                toast(`Failed to ${editFlag ? 'edit' : 'create'} Tray Request`, { variant: 'error' });
            }
        } catch (error) {
            console.error("Error submitting the form:", error);
            toast("An error occurred while processing your request", { variant: 'error' });
        } finally {
            setLoading(false);
        }
    };

    const handleRowDelete = (row) => {
        console.log("HELLLO ID OF ROW", row)
        setMedicineDetails((prev) => prev.filter((data) => data.id !== row));
    };


    useEffect(() => {
        if (productStock && productStock.length > 0) {
            setOriginalData(productStock);
            setIsFiltered(false);
        }
    }, [productStock]);

    const handleProductSearch = (searchValue) => {
        const lowercasedInput = searchValue.toLowerCase();
        const filtered = indoorRegisterationDataObj.filter((item) =>
            item.productDetails[0].product?.toString().toLowerCase().includes(lowercasedInput)
        );
        setOriginalData(filtered);
    };

    const handleChangelk = (e) => {
        const newInput = e.target.value;
        setInput(newInput);
        handleProductSearch(newInput);
    };


    const calculateAge = (dob) => {
        const birthDate = new Date(dob);
        const today = new Date();
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDifference = today.getMonth() - birthDate.getMonth();
        if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        return age;
    };

    const handleRowClick = (row) => {
        console.log("HELLLLO ROW", row)
        setValue('patient_name', row?.patient?.name)
        setValue('uhid', row?.uhid)
        setValue('ipd_no', row?.ipd_no)
        setValue('consultant', row?.consultant_detail?.doctor?._id)
        setValue('gender', row?.patient?.gender)
        setValue('age', calculateAge(row?.patient?.dob))
        setValue('room', row?.consultant_detail?.room?._id)
        setValue('ward', row?.consultant_detail?.room?.ward._id)
        setValue('bed_no', row?.consultant_detail?.bed_no)
        setValue('sponsor', row?.patient?.sponsor)
    };

    const handleRowOpdClick = (row) => {
        console.log("HELLLLO ROW", row)
        setValue('patient_name', `${row?.name_suffix}${row?.first_name}  ${row?.last_name}`)
        setValue('gender', `${row?.gender}`)
        setValue('age', calculateAge(row?.dob))
        setValue('uhid', row?.uhid)
        setValue('consultant', row?.consultant?._id)
        doctorIDRef.current = row?.consultant?._id;
        setValue('sponsor', row?.sponsor?._id)

    };


    const handleQtyChange = (e) => {
        setQty(e.target.value);
    };

    const fetchIpdPatient = async () => {
        setIndoorRegisterationDataObj({ loading: true });
        const response = await request('/indoor-registeration-list', { method: 'GET' });
        if (response.success) {
            const sortedData = response.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
            const filteredData = sortedData.filter(item => item.admission_status === "admit");
            setIndoorRegisterationDataObj({ loading: false, data: filteredData });
            setIpdData(sortedData)
            setIpdFilterData({ data: filteredData });
        } else {
            toast('Error in fetching data', { variant: 'error' });
            setIndoorRegisterationDataObj({ loading: false });
        }
    };




    useEffect(() => {
        fetchIpdPatient()
    }, [])

    const saleMode = watch('sale_mode')
    const handleOpdPatient = (row) => {
        setOpdPatientDetail(row)
        console.log("HELLO OPD PATEINT DETAILS", opdPatientDetail)
        setOpdDialogueOpen(false)
    }

    const handleIpdRow = (row) => {
        setIpdPatientDetail(row)
        console.log("HELLO IPD PATEINT DETAILS", ipdPatientDetail)
        setIpdDialogueOpen(false)
    }
    const handleAdd = () => {
        if (!selectedRow) return;
        const updatedRow = {
            ...selectedRow,
            bill_qty: qty,
        };
        const updatedTableData = tableData.some(row => row._id === selectedRow._id)
            ? tableData.map(row => row._id === selectedRow._id ? updatedRow : row)
            : [...tableData, updatedRow];
        setTableData(updatedTableData);
        setQty('');
        setSelectedRow(null);
        if (productRef.current) {
            productRef.current.focus();
        }
    };

    useEffect(() => {
        if (productRef.current) {
            productRef.current.focus();
        }
    }, []);

    const productData = tableData.map((row) => ({
        ...row,
        amount: row.rate * row.bill_qty,
    }));

    const ITEM_DETAIL_HEADER = [
        {
            header: 'Item Name',
            accessor: (row) => row.tray_name,
        },
        {
            header: 'Quantity',
            accessor: 'quantity'
        },
    ];

    const PATIENT_STATUS_HEADER = [
        { header: 'Patient Name', accessor: (row) => `${row?.patientInfo?.name_suffix}${row?.patientInfo?.first_name}${row?.patientInfo?.last_name}        ` },
        {
            header: 'Indent No.', accessor: (row) => row?.
                indent_no
        },
        { header: 'Date', accessor: 'date' },
    ];

    useEffect(() => {
        if (retailSalePosObj && retailSalePosObj.length > 0) {
            setPosData(retailSalePosObj);
            setIsFiltered(false);
        }
    }, [retailSalePosObj]);

    const handlePosData = (searchValue) => {
        const posDataArray = posData.data || [];
        const lowercasedInput = searchValue.toLowerCase();
        const filtered = posDataArray.filter((item) =>
            item.inv_no.toString().toLowerCase().includes(lowercasedInput)
        );
        setPosData({ ...posData, data: filtered });
    };
    const handleChangePos = (e) => {
        const newInput = e.target.value;
        setPosInput(newInput);
        handlePosData(newInput);
    }


    useEffect(() => {
        if (opdData && opdData.length > 0) {
            setOpdFilterData({ data: opdData });
            setIsFiltered(false);
        }
    }, [opdData]);

    const handleOpdDataFilter = (searchValue) => {
        const opdDataArray = opdFilterData.data || [];
        const lowercasedInput = searchValue.toLowerCase();

        const filtered = opdDataArray.filter((item) =>
            item.uhid.toString().includes(lowercasedInput)
        );
        setOpdFilterData((prevData) => ({ ...prevData, data: filtered }));
    };

    const handleOpdChange = (e) => {
        const newInput = e.target.value;
        setOpdInput(newInput);
        handleOpdDataFilter(newInput);
    };

    useEffect(() => {
        if (indoorRegisterationDataObj && Array.isArray(indoorRegisterationDataObj.data)) {
            setIpdFilterData({ data: indoorRegisterationDataObj.data });
            setIsFiltered(false);
        }
    }, [indoorRegisterationDataObj]);

    const handleIpdDataFilter = (searchValue) => {
        const ipdDataArray = ipdFilterData?.data || [];
        const lowercasedInput = searchValue.toLowerCase();
        const filtered = ipdDataArray.filter((item) =>
            item.uhid.toString().includes(lowercasedInput) ||
            item.ipd_no.toString().includes(lowercasedInput)
        );
        setIpdFilterData((prevData) => ({ ...prevData, data: filtered }));
    };
    const handleIpdChange = (e) => {
        const newInput = e.target.value;
        setIpdInput(newInput);
        handleIpdDataFilter(newInput);
    };


    useEffect(() => {
        if (indoorRegisterationDataObj && Array.isArray(indoorRegisterationDataObj.data) && indoorRegisterationDataObj.data.length > 0) {
            setOriginalData(indoorRegisterationDataObj.data);
            setIsFiltered(false);
        }
    }, [indoorRegisterationDataObj.data]);


    useEffect(() => {
        if (patientDataObj && Array.isArray(patientDataObj.data) && patientDataObj.data.length > 0) {
            setOriginalOpdData(patientDataObj.data);
            setIsFiltered(false);
        }
    }, [patientDataObj.data]);

    useEffect(() => {
        handlePatientSearch(input);
        handleOpdPatientSearch(input)
    }, [input]);

    const handlePatientSearch = (searchInput) => {
        if (Array.isArray(indoorRegisterationDataObj.data)) {
            const lowercasedInput = searchInput.toLowerCase();
            const filtered = indoorRegisterationDataObj.data.filter((item) => {
                const IpdMatch = item.ipd_no.toString().toLowerCase().includes(lowercasedInput)
                const firstNameMatch =
                    item.patient &&
                    item.patient.name &&
                    item.patient.name.toLowerCase().includes(lowercasedInput);

                return IpdMatch || firstNameMatch;
            });
            setOriginalData(filtered);
            setIsFiltered(true);
        }
    };

    const handleOpdPatientSearch = (searchInput) => {
        if (Array.isArray(patientDataObj.data)) {
            const lowercasedInput = searchInput.toLowerCase();
            const filtered = patientDataObj.data.filter((item) => {
                const uhidMatch = item.uhid && item.uhid.toString().toLowerCase().includes(lowercasedInput);
                const firstNameMatch =
                    item.first_name &&
                    item.first_name &&
                    item.first_name.toLowerCase().includes(lowercasedInput);

                return uhidMatch || firstNameMatch;
            });

            setOriginalOpdData(filtered);
            setIsFiltered(true);
        }
    };


    const handleChange = (e) => {
        const newInput = e.target.value;
        setInput(newInput);
    };




    const handleQueryWindow = async () => {
        setOpenQueryDialog(true);
        setTrayRequestDataObj({ loading: true });
        const response = await request('/tray-request-list', { method: 'GET' });
        if (response?.success) {
            const sortedData = response.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
            setTrayRequestDataObj({ loading: false, data: sortedData });
        } else {
            toast('Error in fetching data', { variant: 'error' });
            setTrayRequestDataObj({ loading: false });
        }
    };

    return (
        <>
            <Paper sx={{
                p: 0, flex: 1, borderRadius: 0, boxShadow: 'none',
                width: '100%',
                height: 'auto'
            }}>
                <Container
                    sx={{
                        mt: 1,
                        border: '0px solid',
                        borderColor: 'grey.300',
                        borderRadius: 1,
                        width: '100%',
                        maxWidth: 'none',
                        minWidth: "100%",
                        boxSizing: 'border-box',
                    }}
                >
                    <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)} >
                        <Stack
                            direction="row"
                            spacing={2}
                            justifyContent="space-between"
                            alignItems="center"
                            sx={{
                                mb: 1,
                                borderBottom: '0px solid',
                                borderColor: 'grey.300'
                            }}
                        >
                            <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                                CSSD  Tray Request
                            </Typography>
                            <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                                <CustomButtonn
                                    id={`${lastPathSegment}Write`}
                                    variant="contained"
                                    disabled={['edit', 'new'].includes(currentAction)}
                                    onClick={() => {
                                        setSelectedRecord();
                                        setCurrentAction('new');
                                        setDetailList([])
                                        setMedicineDetails([])
                                        setServiceDetails([])
                                        setLabDetails([])
                                        reset()
                                    }}
                                >
                                    New
                                </CustomButtonn>
                                <CustomButtonn
                                    id={`${lastPathSegment}Update`}
                                    variant="contained"
                                    disabled={['new', 'edit'].includes(currentAction) || !selectedRecord}
                                    onClick={() => setCurrentAction('edit')}
                                >
                                    Edit
                                </CustomButtonn>
                                <CustomButtonn
                                    id={"Submit"}
                                    type="submit"
                                    variant="contained"
                                    disabled={!['edit', 'new'].includes(currentAction) || loading}
                                >
                                    Save
                                </CustomButtonn>
                                <CustomButtonn
                                    id={"Cancel"}
                                    variant="contained"
                                    disabled={['edit', 'new'].includes(currentAction) || loading}
                                    onClick={() => {
                                        setCurrentAction();
                                    }}
                                >
                                    Cancel
                                </CustomButtonn>
                                <CustomButtonn
                                    id={`isSuperAdmin`}
                                    variant="contained"
                                    disabled={!selectedRecord || ['new', 'edit'].includes(currentAction) || loading}
                                >
                                    Delete
                                </CustomButtonn>
                                <CustomButtonn
                                    id={`${lastPathSegment}Read`}
                                    variant="contained"
                                    disabled={['new', 'edit'].includes(currentAction)}
                                    onClick={() => {
                                        handleQueryWindow()
                                    }}
                                >
                                    Query
                                </CustomButtonn>
                                <CustomButtonn
                                    id={`${lastPathSegment}Print`}
                                    variant="contained"
                                    onClick={() => window.open(`/print${pathname}?refId=${selectedRecord._id}`, '_blank')}
                                    disabled={!selectedRecord || currentAction}
                                >
                                    Print
                                </CustomButtonn>
                                <CustomButtonn id={"Exit"} variant="contained"
                                    onClick={() => {
                                        setCurrentAction('');
                                    }}
                                >Exit</CustomButtonn>
                            </Stack>
                        </Stack>
                        <Box sx={{ border: '0px solid gray', padding: 2, borderRadius: '8px', width: '100%', boxShadow: '0px 2px 10px #0099ff' }}>
                            <Grid container spacing={1}>
                                <Grid item xs={4} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>
                                    <Grid item sx={{ display: 'flex', flexDirection: 'column', marginTop: "1%" }}>
                                        <Stack direction="row" spacing={2} alignItems="center" justifyContent="center">
                                            <MuiTextField
                                                sx={{
                                                    width: '100%',
                                                    '& .MuiOutlinedInput-root': {
                                                        padding: '0',
                                                    },
                                                    '& .MuiOutlinedInput-input': {
                                                        padding: '8px 14px',
                                                        fontSize: '1.4rem',  // Adjust font size here
                                                    },
                                                }}
                                                label="Search Admitted Patient"
                                                variant="outlined"
                                                value={input}
                                                onChange={handleChange}
                                                inputRef={productRef}
                                            />
                                        </Stack>
                                        {
                                            selectedIndentRadio === 'ipd_indent' ? (
                                                <Table
                                                    containerSX={{ flex: 1, border: '0px solid rgba(0,0,0,0.27)' }}
                                                    data={currentAction === 'new' ? originalData : []}
                                                    columns={IPD_TABLE_HEADER}
                                                    size="small"
                                                    onRowClick={(row) => {
                                                        handleRowClick(row);
                                                    }}
                                                />
                                            ) : (
                                                <Table
                                                    containerSX={{ flex: 1, border: '0px solid rgba(0,0,0,0.27)' }}
                                                    data={currentAction === 'new' ? originalOpdData : []}
                                                    columns={OPD_TABLE_HEADER}
                                                    size="small"
                                                    onRowClick={(row) => {
                                                        handleRowOpdClick(row);
                                                    }}
                                                />
                                            )
                                        }
                                    </Grid>
                                </Grid>

                                <Grid item xs={8} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>
                                    <Stack sx={{ border: "0px solid grey", padding: "5px", borderRadius: "5px", boxShadow: '0px 2px 2px #0099ff' }} spacing={0.5} direction="row">
                                        <Grid item xs={4} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>

                                            <Stack spacing={0.5} direction="row" alignItems="center">
                                                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem', }}>Sponsor</Typography>
                                                <SelectTag
                                                    disabled={!['new', 'edit'].includes(currentAction)}
                                                    formControlSX={{ flex: 0.8 }}
                                                    name="sponsor"
                                                    placeholder="Select Sponsor"
                                                    menus={sponsorDropdown}
                                                />
                                            </Stack>
                                            <Stack spacing={0.5} direction="row" alignItems="center">
                                                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem', }}>Ward</Typography>
                                                <SelectTag
                                                    disabled={!['new', 'edit'].includes(currentAction)}
                                                    formControlSX={{ flex: 0.8 }}
                                                    name="ward"
                                                    placeholder="Select Ward"
                                                    onChange={() => {
                                                        setValue('room', '');
                                                        setValue('bed_no', '');
                                                    }}
                                                    menus={wardDropdown}
                                                />
                                            </Stack>
                                            <Stack spacing={0.5} direction="row" alignItems="center">
                                                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Room/Bed</Typography>
                                                <SelectTag
                                                    disabled={!['new', 'edit'].includes(currentAction)}
                                                    formControlSX={{ flex: 0.4 }}
                                                    name="room"
                                                    menus={roomMasterDropdown
                                                        .filter(
                                                            (data) =>
                                                                data.ward === watch('ward')
                                                        )
                                                        .map((data) => ({ ...data, name: data.room_no }))}
                                                    onChange={() => {
                                                        setValue('bed_no', '');
                                                    }}
                                                    placeholder="Select Room"
                                                />
                                                <TextField
                                                    disabled={!['new', 'edit'].includes(currentAction)}
                                                    sx={{ flex: 0.4 }}
                                                    name="bed_no"
                                                    placeholder="Bed No."
                                                />

                                            </Stack>
                                            <Stack spacing={0.5} direction="row" alignItems="center">
                                                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem', }}>Remarks</Typography>
                                                <TextField
                                                    disabled={!['new', 'edit'].includes(currentAction)}
                                                    sx={{ flex: 0.8, width: '100%' }}  // Full width of the parent container
                                                    name="remarks"
                                                    placeholder="Remarks"
                                                />
                                            </Stack>
                                        </Grid>
                                        <Grid item xs={4} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>
                                            <Stack spacing={0.5} direction="row" alignItems="center">
                                                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem', }}>Req No.</Typography>
                                                <TextField
                                                    disabled
                                                    sx={{ flex: 0.8, border: currentAction ? "0.5px solid red" : "" }}
                                                    name="req_no"
                                                    placeholder="Req No."
                                                />
                                            </Stack>
                                            <Stack spacing={0.5} direction="row" alignItems="center">
                                                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem', }}>Location To</Typography>
                                                <SelectTag
                                                    disabled={!['new', 'edit'].includes(currentAction)}
                                                    formControlSX={{ flex: 0.8 }}
                                                    name="location_to"
                                                    placeholder="Location To"
                                                    menus={warehouse.map((data) => ({
                                                        ...data, name: data.
                                                            warehouse_name
                                                    }))}
                                                />
                                            </Stack>
                                            <Stack spacing={0.5} direction="row" alignItems="center">
                                                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem', }}>Gender/Age</Typography>
                                                <SelectTag
                                                    disabled={!['new', 'edit'].includes(currentAction)}
                                                    formControlSX={{ flex: 0.4 }}
                                                    name="gender"
                                                    placeholder="Select Gender"
                                                    menus={GENDER_DROPDOWN}
                                                />
                                                <TextField
                                                    disabled={!['new', 'edit'].includes(currentAction)}
                                                    sx={{ flex: 0.4 }}
                                                    name="age"
                                                    placeholder="Age"
                                                />
                                            </Stack>


                                            {/* <Stack spacing={0.2} direction="row" alignItems="center">
                      <Button sx={{ fontWeight: 700, fontSize: '0.7rem', }} variant="contained">Show Alternate Medicine</Button>
                    </Stack> */}
                                        </Grid>
                                        <Grid item xs={4} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>
                                            <Stack spacing={0.5} direction="row" alignItems="center">
                                                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem', }}>Date/Time</Typography>
                                                <TextField
                                                    disabled={!['new', 'edit'].includes(currentAction)}
                                                    sx={{ flex: 0.4, border: currentAction ? "0.5px solid red" : "" }}
                                                    name="date"
                                                    type="date"
                                                />
                                                <TextField
                                                    disabled={!['new', 'edit'].includes(currentAction)}
                                                    sx={{ flex: 0.4, border: currentAction ? "0.5px solid red" : "" }}
                                                    name="time"
                                                    type="time"
                                                />
                                            </Stack>
                                            <Stack spacing={0.5} direction="row" alignItems="center">
                                                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Ipd/Uhid No.</Typography>
                                                <TextField
                                                    disabled={!['new', 'edit'].includes(currentAction)}
                                                    sx={{ flex: 0.4 }}
                                                    name="ipd_no"
                                                    placeholder="Ipd No."
                                                />
                                                <TextField
                                                    disabled={!['new', 'edit'].includes(currentAction)}
                                                    sx={{ flex: 0.4 }}
                                                    name="uhid"
                                                    placeholder="Uhid"
                                                />
                                            </Stack>
                                            <Stack spacing={0.5} direction="row" alignItems="center">
                                                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Consultant</Typography>
                                                <SelectTag
                                                    disabled={!['new', 'edit'].includes(currentAction)}
                                                    formControlSX={{ flex: 0.8 }}
                                                    name="consultant"
                                                    placeholder="Select Consultant"
                                                    menus={doctorDropdown}
                                                />
                                            </Stack>

                                        </Grid>
                                    </Stack>
                                    <Typography onClick={() => {
                                        setCssdDialogeOpen(true)
                                    }} sx={{ fontWeight: 700, fontSize: '1.4rem', color: "blue", cursor: "pointer" }}>Add Details</Typography>
                                    <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'row', gap: 0.3 }}>
                                        <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'row', gap: 0.3 }}>
                                            <Table
                                                containerSX={{ flex: 1, border: '1px solid rgba(0,0,0,0.27)' }}
                                                data={[
                                                    ...medicinesDetails.map((data) => ({ _id: data.id, ...data })),
                                                ]}
                                                columns={ITEM_DETAIL_HEADER}
                                                size="small"
                                                showDeleteAction={true}
                                                onDeleteHandler={handleRowDelete}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Box>
                    </FormProvider>
                </Container >
            </Paper >


            <Dialog
                open={cssdDialogueOpen}
                onClose={() => setCssdDialogeOpen(false)}
                PaperProps={{ sx: { width: '60%', height: '70vh', p: 2 } }}
                maxWidth="xl"
                scroll="body"
            >
                <AddTrayDetailsForm
                    onClose={() => setCssdDialogeOpen(false)}
                    onAdd={(row) => {
                        setMedicineDetails((prev) => [...prev, row]);
                    }}
                />
            </Dialog>


            <Dialog
                open={openQueryDialog}
                onClose={() => setOpenQueryDialog(false)}
                PaperProps={{ sx: { width: '80%', p: 2 } }}
                maxWidth="xl"
                scroll="body"
            >
                <Stack
                    padding={0}
                    direction="row"
                    spacing={2}
                    alignItems="center"
                    justifyContent="space-between"
                    borderBottom="1px solid"
                    borderColor="grey.300"
                >
                    <Typography variant="h4" fontWeight="bold">
                        Tray Request Query Window
                    </Typography>
                    <IconButton onClick={() => setOpenQueryDialog(false)}>
                        <CloseIcon color="error" fontSize="large" />
                    </IconButton>
                </Stack>
                <Stack>
                    <MuiTextField
                        sx={{
                            width: '100%',
                            '& .MuiOutlinedInput-root': {
                                padding: '0',
                                fontSize: '1.4rem' // Adjust input font size
                            },
                            '& .MuiOutlinedInput-input': {
                                padding: '8px 1.4rem'
                            },
                            '& .MuiInputLabel-root': {
                                fontSize: '1.2rem' // Adjust label font size
                            }
                        }}
                        label="Search Trays"
                        variant="outlined"
                        value={input}
                        InputProps={{
                            style: {
                                fontSize: '12px',
                                fontWeight: 600
                            },
                        }}
                    />
                </Stack>
                <Table
                    sx={{ mt: 0.5 }}
                    columns={TABLE_HEADER}
                    data={trayRequestDataObj.data || []}
                    loading={trayRequestDataObj.loading}
                    onRowClick={(row) => {
                        setSelectedRecord(row);
                        setOpenQueryDialog(false);
                    }}
                />
            </Dialog>
        </>
    );
};
